import moment from 'moment';
import { loadImage } from '../util/image'
import { formatDateDetail } from '../util/date/date-detail';
import { formatUrlSeo } from '../util/seo-url';

export default class {
  public id
  public moTa
  public noiDung
  public hinhThumbnail
  public hinhFull
  public tieuDe
  public tenDanhMuc
  public timePublish
  public url
  public danhMuc
  public danhMucTen
  public danhMucTenKhongDau
  public danhMucTinID
  public seo
  public slView;
  public ngay;
  public thang;
  public nam;
  public url_seo_tin;
  public files;

  constructor(options) {
    options.hinh = options.hinh ? options.hinh : {}
    options.json_seo = options.json_seo ? options.json_seo : {}
    this.id = options.tin_tuc_id || null
    this.moTa = options.mo_ta || ''
    this.noiDung = options.noi_dung || ''
    this.hinhThumbnail = options.hinh.hinh_goc
      ? loadImage(options.hinh.hinh_goc)
      : ''
    this.hinhFull = options.hinhFull || ''
    this.tieuDe = options.tieu_de || ''
    this.tenDanhMuc = options.ten_danh_muc || ''
    this.timePublish = options.time_publish
      ? formatDateDetail(new Date(options.time_publish))
      : ''
    this.url = options.url || ''
    this.danhMucTen = options.danh_muc_ten || ''
    this.danhMucTenKhongDau = options.danh_muc_ten_khong_dau || ''
    this.danhMucTinID = options.danh_muc_tin_id
    this.seo = {
      title: options.json_seo.tieu_de || '',
      moTa: options.json_seo.mo_ta || '',
      status: options.json_seo.status || false,
      tag: options.json_seo.tag_seo || [],
      hinh: options.json_seo.hinh_seo || '',
    }
    this.slView = options.sl_view;
    this.ngay = moment(options.time_publish).format('DD');
    this.thang = moment(options.time_publish).format('MMM');
    this.nam = moment(options.time_publish).format('YYYY');
    this.url_seo_tin = formatUrlSeo(options.url || '', options.tin_tuc_id || null);
    this.files = options.files || []
  }
}
